import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import TeacherDashboard from '../housekiosk/components/Teacher/TeacherDashboard';
import { UserContext } from '../contexts/UserContext';

export default function HouseKioskTeacherPage() {
  const { userProfile } = useContext(UserContext);
  const role = (userProfile?.mainRole || '').toUpperCase();
  const isTeacherLike = role.includes('TEACHER') || role.includes('ACORNLEAD');

  if (!isTeacherLike) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <TeacherDashboard />;
}
